const initialState = {
  selectedValue: "eth",
};

export const selectReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_SELECTED_VALUE":
      return {
        ...state,
        selectedValue: action.payload,
      };
    default:
      return state;
  }
};
